<template>
  <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg">
    <iframe height="800" class="rounded-lg"
    src="https://app.powerbi.com/view?r=eyJrIjoiNWY2ZjA2YTItYjEwMC00MWI2LTgyZTctOTgwOGE5M2I5YzcwIiwidCI6IjhlNjM0ZTY3LTlkNjYtNDZkMi1hNTI5LWUxYjcwOGM1ZDhiYyIsImMiOjEwfQ%3D%3D" 
    frameborder="0" allowFullScreen="true"></iframe>
  </div>
</template>
